module.exports = __webpack_public_path__ + "themes/mf/img/star.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/star.png
// module id = 110
// module chunks = 3